/*
 * Copyright (c) 2021-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import PropTypes from "prop-types";

class Tab extends Component {
    render() {
        return (
            <div className={"w-full h-full"}>
                {this.props.children}

            </div>
        );
    }
}

Tab.propTypes = {
    eventKey: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]).isRequired,
    iconName: PropTypes.string,
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
};

export default Tab;